const menus = [
    {
        id: 1,
        name: 'Home',
        links: '#',
    },
    {
        id: 2,
        name: 'Explore',
        links: '#',
    },{
        id: 3,
        name: 'Activity',
        links: '#',
    },
    {
        id: 4,
        name: 'Community',
        links: '#',
    },
    {
        id: 5,
        name: 'Page',
        links: '#',
    },
    {
        id: 7,
        name: 'Contact',
        links: '/contact-01',
    },
    
]

export default menus;